import queryString from 'query-string'
import { includes } from 'lodash'
import { svCompareString } from './sort'

export const texts = {
  ALL_SWEDEN: 'Hela Sverige',
  ALL_MUNICIPALITIES: 'Alla områden',
  ADJACENT_MUNICIPALITIES: 'Angränsande län',
  SEVERAL_REGIONS: 'Flera län',
  SEVERAL_MUNICIPALITIES: 'Flera områden',
}

const _flattenLocations = (queryKeys, items, parentValues = {}, level = 1) => {
  let flattened = []
  const sortedItems = [...items].sort((a, b) => svCompareString(a.label, b.label))
  sortedItems.forEach((item) => {
    const queryKey = queryKeys[level - 1]

    const value = {
      ...parentValues,
      [queryKey]: item.value,
    }

    flattened.push({
      value,
      level,
      label: item.label,
      children: item.items ? item.items : null,
    })

    if (item.items) {
      flattened = [...flattened, ..._flattenLocations(queryKeys, item.items, value, level + 1)]
    }
  })
  return flattened
}

export const flattenLocations = (regionParameter) => {
  const queryKeys = [regionParameter.queryKey]

  regionParameter.parameters.forEach(({ queryKey }) => {
    queryKeys.push(queryKey)
  })
  return _flattenLocations(queryKeys, regionParameter.items)
}

export const mapRegionItemToOption = ({ label, value }) => ({ label, value })
export const sortLabelBySv = (a, b) => svCompareString(a.label, b.label)

export const getSingleDropdownRegionOptions = ({ items }) => [
  { label: texts.ALL_SWEDEN, value: '' },
  ...[...items].map(mapRegionItemToOption).sort(sortLabelBySv),
]

export const getRegionOptions = (regionParameter) => {
  const regions = flattenLocations(regionParameter)
    .filter((location) => location.level === 1)
    .map(({ label, value, level }) => {
      return {
        label,
        value: queryString.stringify(value),
        level,
      }
    })

  return [...regions.sort(sortLabelBySv)]
}

export const getSubRegionOptions = (regionParameter, region) => {
  const allSubRegions = flattenLocations(regionParameter)
    .filter((location) => location.value.r === region[0])
    .filter((location) => location.level > 1)
  const subAreas = allSubRegions.filter((subarea) => subarea.level === 3)
  const subRegions = allSubRegions.map(({ label, value, children, level }) => {
    return {
      label,
      value: queryString.stringify(value),
      level,
      children:
        children &&
        subAreas.map(({ label: subAreaLabel, value: subAreaValue, level: subAreaLevel }) => {
          return {
            label: subAreaLabel,
            value: queryString.stringify(subAreaValue),
            level: subAreaLevel,
          }
        }),
    }
  })

  return [...subRegions]
}

// The search parameters for geo prefernces is an object
// where the keys `m`, `sa`, `r` and `ag` defined.
// the "value" undefined means the it's not selected in the geo preference
// and having a string set meaning that it is.
// This function builds that search params object
export const buildGeoSearchParams = (geoPreference) => {
  return {
    r: undefined,
    ag: undefined,
    m: undefined,
    sa: undefined,
    ...geoPreference,
  }
}

export const groupKeyValues = (givenArray, key) => {
  const result = givenArray.reduce((rv, obj) => {
    rv[key] = rv[key] || []
    if (obj[key] && !includes(rv[key], obj[key])) {
      rv[key].push(obj[key])
    }
    return rv
  }, {})
  return result[key] && result[key].length > 0 ? result : {}
}
